import React, { useState, useEffect } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button } from "reactstrap";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Chip from '@mui/material/Chip';
import { Autocomplete } from "@mui/material";
import {TextField} from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import { toast } from 'react-toastify';
import { user_requisition,user_filter,filter_requistion } from "../../api/requisition";
import History from "./History";
import dayjs from 'dayjs';
import { styled } from '@mui/material/styles';
import { useApprovalFilter } from "../../Components/Hooks/UseApprovalFilter";
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../store/pageHeader/action";
const CustomDataGrid = styled(DataGrid)(({ theme }) => ({
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      display: 'flex',
      justifyContent: 'center',
    },
  }));

const RSMRequisitionHistory = () => {

  const dispatch = useDispatch();
  dispatch(StorePageHeaderName('My Requisition'))


  const [open, setOpen] = useState(false)
  const [showList, setShowList] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // New state variable for loading indicator
  const [rows, setRows] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState(null);
  // const [productList, setProductList] = useState([]); // State variable for product list
  // const [selectedProductName, setSelectedProductName] = useState(null);
  // const [reqNoList, setReqNoList] = useState([]); // State variable for product list
  const [selectedReqNo, setSelectedReqNo] = useState(null);
  // const [selectedDate, setSelectedDate] = useState(null);
  // const [selectedEndDate, setSelectedEndDate] = useState(null);
  document.title ="Dashboard | Procurement Dashboard";
  const top100Films = [
    { label: 'The Shawshank Redemption', year: 1994 },
    { label: 'The Godfather', year: 1972 },
    { label: 'The Godfather: Part II', year: 1974 },
    { label: 'The Dark Knight', year: 2008 },
    { label: '12 Angry Men', year: 1957 },]
    const handleProductNameClick = (isOpen,id) => {
      setOpen(isOpen)
      setSelectedRowId(id); // Set the selected row id

    };
    // const handleProductNameChange = (event, value) => {
    //   setSelectedProductName(value);
    // };



  const toggleList = () => {
    setShowList(!showList);
  };

  const columns = [
    { field: 'Sl_No', headerName: 'Sl.No',
    //  width: 70
    headerAlign: 'center',
    cellClassName: 'center-aligndata',
    sortable: false,
    resizable: false,
    flex: 1,
    },
    {
      field: 'Requisition_No',
      headerName: 'Requisition No',
      headerClassName: 'break-header',
      cellClassName: 'product_name_wrap',
      // width: 160,
      editable: false,
      sortable: false,
      resizable: false,
      flex: 1,
    },
    {
      field: 'Requisition_Date',
      headerName: 'Requisition Date',
      headerClassName: 'break-header',
      // width: 160,
      editable: false,
      sortable: false,
      resizable: false,
      flex: 1,
    },
    {
      field: 'Product_Name',
      headerName: 'Product Name',
      headerClassName: 'break-header',
      cellClassName: 'product_name_wrap',
      width: 160,
      editable: false,
      sortable: false,
      resizable: false,
      renderCell: (params) => {
        const productName = params.value;
        // return (
        //   <div onClick={() => handleProductNameClick(true,params.id)}>
        //     {productName}
        //   </div>
        // );
      },
    },
    {
      field: 'Total_Qty',
      headerName: 'Total Quantity',
      headerClassName: 'break-header',
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      flex: 1,
      // width: 110,
    },
    {
      field: 'approved',
      headerName: 'Approved',
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 120,
      flex: 1,
    },
    {
      field: 'remaining',
      headerName: 'Remaining',
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 120,
      flex: 1,
    },
      {
        field: 'Allocation_QTY',
        headerName: 'Allocation (QTY)',
        headerClassName: 'break-header',
        // description: 'This column has a value getter and is not sortable.',
        sortable: false,
        resizable: false,
        headerAlign: 'center',
        cellClassName: 'center-aligndata',
        // width: 130,
        flex: 1,
      },
      {
        field: 'Value',
        headerName: 'Value',
        // description: 'This column has a value getter and is not sortable.',
        sortable: false,
        resizable: false,
        // width: 120,
        headerAlign: 'center',
        cellClassName: 'center-aligndata',
        flex: 1,
      },
      // {
      //   field: 'Actual_Date',
      //   headerName: 'Actual Date',
      //   description: 'This column has a value getter and is not sortable.',
      //   sortable: false,
      //   width: 100,
      // },
      // {
      //   field: 'Modified_Date',
      //   headerName: 'Modified Date',
      //   description: 'This column has a value getter and is not sortable.',
      //   sortable: false,
      //   width: 100,
      // },
       {
        field: 'Arival_Date',
        headerName: 'Arival Date',
        // description: 'This column has a value getter and is not sortable.',
        sortable: false,
        resizable: false,
        headerAlign: 'center',
        cellClassName: 'center-aligndata',
        // width: 130,
        flex: 1,
      },
      {
        field: 'Status',
        headerName: 'Status',
        // description: 'This column has a value getter and is not sortable.',
        sortable: false,
        resizable: false,
        width: 180,
        headerAlign: 'center',
        cellClassName: 'center-aligndata',
        flex: 1,
        renderCell: (params) => {
            let status = params.value;
            let chipColor = 'default';
            if (status === 'Pending') {
              chipColor = 'error'; // Red color for waiting for response
              status = 'Waiting for response'; // Change status text

            } else if (status === 'Approved') {
              chipColor = 'success'; // Green color for approved
            }
            return <Chip className="status_badge mt-1" label={status} variant="outlined" color={chipColor} />;
          },
      },
  ];

  const fetchRequisitionHistory = async (payload = {}) => {
    try {
      setIsLoading(true)
      let count = 0; // Initialize the count variable outside the map function
      const response = await user_requisition(payload);


      let requisitionItems = []
      if(response.statusCode ===200 && response.data.getRequisition.length >0){
        requisitionItems = response.data.getRequisition.flatMap(requisition => requisition.procurementRequisitionItem.map(item => ({
          id: item.id,
          Sl_No: ++count,
          Requisition_No: requisition.requisition_number,
          Requisition_Date:requisition.requisition_date,
          Product_Name: item.item_name,
          Total_Qty: item.total_qty,
          approved: item.approved_qty,
          remaining: item.total_qty - item.approved_qty,
          Value: item.value,
          Allocation_QTY: item.allocation_qty,
          // Actual_Date: '--',
          // Modified_Date:'--',
          Arival_Date: item.arrival_date,
          Status: item.status
        })));

      }
      setRows(requisitionItems); // Update rows state with fetched data

    } catch (error) {
      console.error('Error fetching requisition history:', error);
      toast.error('Something went wrong')
      // Handle error
    }
    finally {
      setIsLoading(false); // Reset loading state after operation completes
  }
  };

  const {
    productList,
    reqNoList,
    statusList,
    filterPayload,
    setFilterPayload,
    handleSearch,
    handleReset
  } = useApprovalFilter({
      showList,
      requisition_role: 'RSM',
      status: null,
      self: true,
      callback: fetchRequisitionHistory
  });

  // useEffect(()=>{
  //   if(showList){
  //     const fetchProductList = async(search_type)=>{
  //       try{

  //         const response = await user_filter({search_type});
  //         if (response.statusCode === 200) {
  //           if(search_type === 'productName'){
  //           if (response.data.product.length > 0) {
  //             setProductList(response.data.product); // Update productList state with fetched data
  //           }

  //         }
  //         else if (search_type === 'reqNo') {
  //           if (response.data.reqNo.length > 0) {
  //             setReqNoList(response.data.reqNo); // Update productList state with fetched data
  //           }
  //         }
  //         }
  //       }
  //       catch (error) {
  //         console.error('Error fetching product list:', error);
  //         toast.error('Something went wrong')

  //       }
  //     }
  //     fetchProductList('productName');
  //     fetchProductList('reqNo');

  //   }

  //   else {
  //     handleReset()
  //   }
  // },[showList])

  // const handleReset = () => {
  //   setSelectedProductName(null);
  //   setSelectedReqNo(null);
  //   setSelectedDate(null);
  //   setSelectedEndDate(null);
  //   fetchRequisitionHistory()
  // };
  useEffect(()=>{
    fetchRequisitionHistory()
  },[])
  const handleRowClick = (params) => {
    handleProductNameClick(true, params.id);
  };
  // const handleReqNoChange = (event, value) => {
  //   setSelectedReqNo(value);

  // };
  // const handleDateChange = (date) => {

  //   setSelectedDate(date)
  // };
  // const handleEndDateChange = (date) => {
  //   setSelectedEndDate(date)
  // };

  // const handleSearch = async() => {
  //   try {
  //     setIsLoading(true); // Set loading state
  //     if ((selectedDate && !selectedEndDate) || (!selectedDate && selectedEndDate)) {
  //       toast.error('Please select valid daterange.');
  //       return;
  //     }

  //     let count = 0;
  //     let searchCriteria = {};

  //     if (selectedProductName) {
  //       searchCriteria.item_no = selectedProductName.value;
  //     }

  //     if (selectedReqNo) {
  //       searchCriteria.requisition_no = selectedReqNo.value;
  //     }
  //     if (selectedDate && selectedEndDate) {
  //       searchCriteria.requisition_date =  dayjs(selectedDate).format('YYYY-MM-DD')
  //       searchCriteria.requisition_end_date =  dayjs(selectedEndDate).format('YYYY-MM-DD')

  //     }

  //     const response = await filter_requistion(searchCriteria);

  //     if (response.statusCode === 200) {
  //       if(response.data.getRequisition.length >0){

  //         const requisitionItems = response.data.getRequisition.flatMap((requisition) =>
  //           requisition.procurementRequisitionItem.map((item) => ({
  //             id: item.id,
  //             Sl_No: ++count,
  //             Requisition_No: requisition.requisition_number,
  //             Requisition_Date: requisition.requisition_date,
  //             Product_Name: item.item_name,
  //             Total_Qty: item.total_qty,
  //             approved: item.approved_qty,
  //             remaining: item.total_qty - item.approved_qty,
  //             Value: item.value,
  //             Allocation_QTY: item.allocation_qty,
  //             // Actual_Date: '--',
  //             // Modified_Date: '--',
  //             Arival_Date: '--',
  //             Status: item.status,
  //           }))
  //         );
  //         setRows(requisitionItems); // Update rows state with fetched data
  //       }
  //       else{
  //         setRows([])
  //       }

  //     }
  //   } catch (error) {
  //     console.error('Error searching requisition:', error);
  //     toast.error('Something went wrong while searching');
  //   } finally {
  //     setIsLoading(false); // Reset loading state after operation completes
  //   }

  // }
  return (
    <React.Fragment>
        {
      open &&(
        <History handleProductNameClick={handleProductNameClick}   selectedRowId={selectedRowId} // Pass selectedRowId
        />
      )
     }
      <div className="page-content">
        <Container fluid>
            {/* <BreadCrumb title="My Requisition" pageTitle="Requisitions"/> */}
            <div>
                <div style={{ display: 'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <div>
                    <h3 className="requisition_text mb-0">Requisition History</h3>
                    </div>
                  <div>
                    <button onClick={toggleList} variant="outlined" className="filter_button"><span className="me-2"><TuneIcon /></span>Filter</button>
                  </div>
                </div>
                {showList && (

                  <div className="mt-2" style={{ display: 'flex',gap:'10px', alignItems: 'center', flexWrap:'wrap'}}>
                  <div>
                      <Autocomplete
                      className="data_field"
                        disablePortal
                        id="combo-box-demo"
                        options={productList}
                        onChange={(_, value) => setFilterPayload({...filterPayload, product:value})}
                        value={filterPayload.product}
                        sx={{ width: 230 }}
                        renderInput={(params) => <TextField {...params} label="Select Product Name" />}
                        // onChange={handleProductNameChange}
                        // value={selectedProductName}
                      />
                      </div>
                      <div>
                      <Autocomplete
                       className="data_field"
                        disablePortal
                        id="combo-box-demo"
                        options={reqNoList}
                        sx={{ width: 200
                        }}
                        onChange={(_, value) => setFilterPayload({...filterPayload, reqNo:value})}
                        value={filterPayload.reqNo}
                        renderInput={(params) => <TextField {...params} label="Requisition Number" />}
                      />
                      </div>
                      <div className="d-flex">
                      {/* <button className="date_button" variant="contained" onClick={datepickeropenModal}>Select Date</button> */}
                        <div>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker className='date_picker'
                            label="From Date"
                            value={filterPayload.startDate}
                            maxDate={filterPayload.endDate}
                            onChange={(value) => setFilterPayload({...filterPayload, startDate:value})}
                              />
                          </LocalizationProvider>
                        </div>
                        <div className="ms-2">
                        <LocalizationProvider className='date_picker' dateAdapter={AdapterDayjs}>
                          <DatePicker className='date_picker'
                            label="To Date"
                            value={filterPayload.endDate}
                            minDate={filterPayload.startDate}
                            onChange={(value) => setFilterPayload({...filterPayload, endDate:value})}
                          />
                        </LocalizationProvider>
                        </div>
                      </div>
                      <div>
                      <Autocomplete
                       className="data_field"
                        disablePortal
                        id="combo-box-demo"
                        options={statusList}
                        onChange={(_, value) => setFilterPayload({...filterPayload, status:value})}
                        value={filterPayload.status}
                        sx={{ width: 170 }}
                        renderInput={(params) => <TextField {...params} label="Status" />}

                      />
                      </div>
                      {/* <div>
                      <Autocomplete
                       className="data_field"
                        disablePortal
                        id="combo-box-demo"
                        options={top100Films}
                        sx={{ width: 170 }}
                        renderInput={(params) => <TextField {...params} label="Executive" />}

                      />
                      </div> */}
                      <div className="d-flex align-items-center">
                      <button className="me-2 search_button" variant="outlined" onClick={handleSearch}>Search</button>
                      <ReplayIcon onClick={handleReset}/>
                      </div>

                  </div>
                )}

                <Box sx={{ height: '100%', width: '100%', marginTop:'10px', marginBottom:'10px' }}>
                    {/* <DataGrid
                      className="table_header_background"
                      headerClassName="custom-header-cell"
                        rows={rows}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 5,
                                },
                            },
                        }}
                        pageSizeOptions={[5]}
                        disableRowSelectionOnClick
                    /> */}
                    <DataGrid
                      autoHeight
                      className="table_header_background"
                      headerClassName="custom-header-cell"
                      getRowHeight={() => 'auto'}
                        rows={rows}
                        columns={columns}
                        loading={isLoading} // Set loading state
                        initialState={{
                            // pagination: {
                            //     paginationModel: {
                            //         pageSize: 5,
                            //     },
                            // },

                        }}
                        pageSizeOptions={[]}
                        disableRowSelectionOnClick
                        onRowClick={handleRowClick}
                        disableColumnMenu
                        componentsProps={{
                          cell: {
                            disableClick: true,
                          },
                        }}
                        sx={{
                          '& .MuiDataGrid-cell': {
                            '& .MuiDataGrid-cell--textOverflow': {
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            },
                          },
                        }}
                    />

                </Box>
            </div>
            {/* <Card>
                        <CardBody className="pt-0 pe-0 ps-0">
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th className="text-center">Item Count</th>
                                            <th className="text-center">Total Quantity</th>
                                            <th className="text-center">Total Approved</th>
                                            <th className="text-center">Total Remaining</th>
                                            <th className="text-center">Total Value</th>


                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td className="text-center">{rows.length}</td>
                                                
                                                <td className="text-center">{rows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.Total_Qty;
                                                }, 0)}</td>
                                                <td className="text-center">{rows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.approved;
                                                }, 0)}</td>
                                                <td className="text-center">{rows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.remaining;
                                                }, 0)}</td>
                                                <td className="text-center">{rows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.Value;
                                                }, 0)}</td>
                                            </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card> */}
        </Container>

      </div>
    </React.Fragment>
  );
};

export default RSMRequisitionHistory;
